// extracted by mini-css-extract-plugin
export var blockContainer = "styles-module--blockContainer--19da0";